<template>
  <!--框架设置-->
  <div class="wh100b analysisSet"  v-if="showType==='analysisSet'" style="padding: 8px;">
    <analysisSet/>
  </div>
  <!--模版预览显示 -->
  <div class="wh100b appTemplate" v-if="showType==='templateApp'">
    <app-template-show/>
  </div>
  <!--应用显示-->
  <AppFrameLayout v-if="showAppFlag&&(showType!=='analysisSet'&&showType!=='templateApp')"
                  :showType="showType"
                  :appId="appId"
                  :templateId="templateId"
                  :back="false" ref="frameLayoutCtl"/>
</template>


<script setup lang="ts">
import {nextTick, ref} from "vue";
import {useLayout} from '../../hooks/layouts/useLayout';
import AnalysisSet from "@/views/dashboard/analysisSet/index.vue";
import AppFrameLayout from './appFrame/AppFrameLayout.vue';
import {useAppStore} from "@/store/modules/app";
import {getAppObjByAppId} from "@/api/sys/portalSpace";
import {getUrlParams, StorageUtils} from 'xmgoing-utils';
import {useUserStore} from "@/store/modules/user";
import GoingUtils from "@/utils/goingUtils";
import AppTemplateShow from "@/layouts/layoutFrame/app-template-show.vue";

const props=defineProps({
  templateId:{
    type:String,
    default:''
  },
  appId:{
    type:String,
    default:''
  },
  showType:{
    type:String,
    default:''
  }
});
const {showType} = toRefs(props);

const { setting,getLayout } =  useLayout(props);
const appStore = useAppStore();
appStore.setShowRouterFlag(false);
appStore.setLayout("appFrame");

const showAppFlag=ref(false);
const userStore = useUserStore();

const frameLayoutCtl:any=ref(null);

nextTick(()=>{
  //如果存在模版id
  if(props.templateId){
    StorageUtils.addSessionItem("showApp","true");
  }
  if(props.appId){
    setAndOpenPage(getUrlParams("sessionId",true)||StorageUtils.getSessionItem("sessionId"),props.appId,props.templateId);
  }
  showAppFlag.value=true;
})

const setAndOpenPage=async (sessionId,appId,templateId)=>{
  userStore.setToken(sessionId);
  StorageUtils.addSessionItem("sessionId",sessionId);
  StorageUtils.addSessionItem("appName",getUrlParams("appName",true)||StorageUtils.getSessionItem("appName"));
  StorageUtils.addSessionItem("appId",appId);
  userStore.setShowAppFlag(true);
  StorageUtils.addSessionItem("showApp","true");
  StorageUtils.addSessionItem("templateId",templateId);
  //如果不是模版预览 是 应用预览则查询应用信息
  if(!templateId&&appId){
    const res = await getAppObjByAppId(appId);
    appStore.setAppObj(res);
  }
}

</script>
<style  lang="less">
.analysisSet{
  background-color: #F7F8FA;
  .vben-layout-left-menu{
    height:calc(100% - 16px);
  }
}
</style>
